import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, useTheme, Box } from "@mui/material";

export default function RoutesBtn({ nav }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const handleContactUsClick = () => {
    navigate("/contact-us");
  };

  const handleLoginClick = () => {
    navigate("/admin/login");
  };

  return (
    <Box display="flex" flexDirection={nav ? "row" : "column"} gap={1.5} alignItems="center">
      <Button
        size={nav ? "medium" : "large"}
        fullWidth={!nav}
        variant="contained"
        onClick={handleContactUsClick}
        sx={{ color: theme.palette.common.white }}
      >
        Contact Us
      </Button>

      {!token && (
        <Button
          size={nav ? "medium" : "large"}
          fullWidth={!nav}
          variant="outlined"
          color="primary"
          onClick={handleLoginClick}
          sx={{ fontWeight: 600, borderRadius: 2, textTransform: "none" }}
        >
          Log in
        </Button>
      )}
    </Box>
  );
}
